const Accordion = {
	bindEvents: () => {
		// Fetch all the details element.
		const details = document.querySelectorAll("[data-js-accordion]")

		// Add the onclick listeners.
		let i = 0
		details.forEach((targetDetail) => {
			if (i == 0) {
				targetDetail.setAttribute("open", "open")
			}
			targetDetail.addEventListener("click", () => {
				// Close all the details that are not targetDetail.
				details.forEach((detail) => {
					if (detail !== targetDetail) {
						detail.removeAttribute("open")
					}
				})
				setTimeout(function() {
					targetDetail.scrollIntoView({ behavior: "smooth" })
				}, 50)
			})
			i++
			// handle FDES Files accordion
			Accordion.handleFDES(targetDetail)
		})
	},

	handleFDES: (accordion) => {
		if (document.body.offsetWidth < 768) {
			const filesContainer = accordion.querySelector(".accordion-item__content__row.files")
			const filesElements = filesContainer.querySelectorAll(".tease-file")
			if (filesContainer && filesElements.length) {
				let viewableHeight = filesElements[0].offsetHeight
				if (filesElements[1]) {
					viewableHeight += 54 + filesElements[1].offsetHeight
				}
				filesContainer.style.maxHeight = viewableHeight + "px"
			}
		}
	},
}

export default Accordion
